import { domainEvent } from "@lookiero/messaging";
const UI_SETTING_UPDATED = "ui_setting_updated";
const uiSettingUpdated = ({ aggregateId }) => domainEvent({ aggregateId, name: UI_SETTING_UPDATED });
const isUiSettingUpdated = (event) => event.name === UI_SETTING_UPDATED;
export { UI_SETTING_UPDATED, uiSettingUpdated, isUiSettingUpdated };
